export default __webpack_public_path__ + "static/media/9.Fire-Hose-Reel.b683b640.jpg";